// extracted by mini-css-extract-plugin
module.exports = {"aspectContainer":"PopularDestinationsCard_aspectContainer__YWwDC","overlay":"PopularDestinationsCard_overlay__XBEki"};